import classNames from 'classnames';
import { useState } from 'react';

import { HeaderCommonProps } from '~components/Headers/HeaderCommon/HeaderCommon.types';
import { HeaderLogo } from '~components/Headers/HeaderCommon/HeaderLogo/HeaderLogo';
import { HeaderNavItem } from '~components/Headers/HeaderCommon/HeaderNavItem/HeaderNavItem';
import { HeaderNavToggle } from '~components/Headers/HeaderCommon/HeaderNavToggle/HeaderNavToggle';
import { LayoutContainer } from '~components/LayoutContainer/LayoutContainer';
import { LayoutContainerMods } from '~components/LayoutContainer/LayoutContainer.types';
import { ButtonRenderer } from '~containers/Buttons/ButtonRenderer/ButtonRenderer';
import { useBreakpoints } from '~hooks/useBreakpoints';
import { useScrollLock } from '~hooks/useScrollLock';
import { useStickyHeader } from '~hooks/useStickyHeader';

import styles from './HeaderCommon.module.scss';

// TODO: компонент частично взят из mark-ui. В дальнейшем - заменить на mark-ui !
// В компоненте исключено: меню (items), так как у блога - оно свое; langDropdown

export const HeaderCommon = ({
  catalog: {
    logo,
    additionalButtonsData,
    additionalBlockData,
    stickyStartFrom,
    throttleDelay,
    disabledScrollEffects,
    stickyTarget = 'both',
    items,
  },
}: HeaderCommonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleHeaderToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const { isSticky, isScrolledUp, hasTransition } = useStickyHeader({
    stickyStartFrom: stickyStartFrom,
    throttleDelay: throttleDelay,
    disabledScrollEffects: disabledScrollEffects,
  });

  const [, { isDesktop }] = useBreakpoints();

  useScrollLock(isOpen);

  const additionalButtons = (
    <div className={styles.buttons}>
      {additionalButtonsData?.map((item) => (
        <ButtonRenderer {...item} key={item.id} />
      ))}
    </div>
  );
  const additionalBlock = additionalBlockData?.map((item) => (
    <ButtonRenderer {...item} key={item.id} />
  ));

  return (
    <>
      {stickyTarget === 'header' && (
        <header
          className={classNames(styles.header, {
            [styles.sticky]: isSticky && stickyTarget === 'header',
            [styles.hidden]:
              isSticky && !isScrolledUp && stickyTarget === 'header',
            [styles.hasTransition]: hasTransition && stickyTarget === 'header',
          })}
        >
          <LayoutContainer mods={[LayoutContainerMods.Inner]}>
            <div className={styles.headerContainer}>
              <div
                className={styles.logoContainer}
                data-testid="logo-container"
              >
                <div onClick={handleHeaderToggle}>
                  <HeaderNavToggle
                    className={styles.headerNavToggle}
                    isActive={isOpen}
                  />
                </div>
                {logo && <HeaderLogo {...logo} />}
              </div>
              <div className={styles.btnContainer}>
                {isDesktop && additionalButtons && (
                  <div className={styles.consultButton}>
                    {additionalButtons}
                  </div>
                )}
                {additionalBlock && (
                  <div className={styles.additionalBlock}>
                    {additionalBlock}
                  </div>
                )}
              </div>
            </div>
          </LayoutContainer>
        </header>
      )}
      <div
        className={classNames(styles.wrapper, {
          [styles.sticky]: isSticky && stickyTarget === 'both' && !isOpen,
          [styles.hidden]:
            isSticky && !isScrolledUp && stickyTarget === 'both' && !isOpen,
          [styles.hasTransition]:
            hasTransition && stickyTarget === 'both' && !isOpen,
          [styles.open]: isDesktop ? false : isOpen,
        })}
        data-testid="wrapper"
      >
        {stickyTarget !== 'header' && (
          <header className={classNames(styles.header)}>
            <LayoutContainer mods={[LayoutContainerMods.Inner]}>
              <div className={styles.headerContainer}>
                <div
                  className={styles.logoContainer}
                  data-testid="logo-container"
                >
                  <div onClick={handleHeaderToggle}>
                    <HeaderNavToggle
                      className={styles.headerNavToggle}
                      isActive={isOpen}
                    />
                  </div>
                  {logo && <HeaderLogo {...logo} />}
                  {isDesktop
                    ? items?.map((item) => (
                        <div key={item.id} className={styles.navItem}>
                          <HeaderNavItem {...item} />
                        </div>
                      ))
                    : undefined}
                </div>

                <div className={styles.btnContainer}>
                  {isDesktop && additionalButtons && (
                    <div className={styles.consultButton}>
                      {additionalButtons}
                    </div>
                  )}
                  {additionalBlock && (
                    <div className={styles.additionalBlock}>
                      {additionalBlock}
                    </div>
                  )}
                </div>
              </div>
            </LayoutContainer>
          </header>
        )}
        {!isDesktop && (
          <div className={styles.menuContainer}>
            <nav
              className={classNames(styles.nav, {
                [styles.open]: isDesktop ? false : isOpen,
              })}
            >
              {additionalButtons && (
                <div className={styles.consultButtonMobile}>
                  {additionalButtons}
                </div>
              )}

              {items?.map((item) => (
                <div key={item.id} className={styles.navItem}>
                  <HeaderNavItem {...item} />
                </div>
              ))}
            </nav>
          </div>
        )}
      </div>
    </>
  );
};
